import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import _ from 'lodash';
import { Header, HubSidebar } from '../../components';
import { automationActions } from '../../webapi';
import { whiteLabelLoaded } from '../../actions';
import { getApiError } from '../../session';
import AWSAccount from './AWSAccount';
import CommunityManagerSetup from './CommunityManagerSetup';
import AppSetupiOS from './AppSetupiOS';
import AppSetupAndroid from './AppSetupAndroid';
import Deployment from './Deployment';
import Extensions from './Extensions';
import AddSubApp from './AddSubApp';
import AddAppLinks from './AddAppLinks';
import ReplaceAppColours from './ReplaceAppColours';
import ReplaceAppAssets from './ReplaceAppAssets';
import BuildApp from './BuildApp';
import AppDashboard from './AppDashboard';

// Shortcut keys
const SHORTCUT_WHITELABEL = 'whitelabel';
const SHORTCUT_SECONDARY_APP = 'secondaryApp';
const SHORTCUT_APP_COLOURS = 'appColours';
const SHORTCUT_APP_IMAGES = 'appImages';
const SHORTCUT_APP_LINKS = 'appLinks';
const SHORTCUT_STORE_UPGRADE = 'storeUpgrade';
const SHORTCUT_BEAMED_UPGRADE = 'beamedUpgrade';
const SHORTCUT_FEATURE_ADDITION = 'featureAddition';
const SHORTCUT_APP_DASHBOARD = 'appDashboard';

// Shortcut sections
const SHORTCUT_SECTION_CREATION = 'Creation';
const SHORTCUT_SECTION_BRANDING = 'Branding Changes';
const SHORTCUT_SECTION_LINKS = 'App Store Links';
const SHORTCUT_SECTION_UPDATES = 'Updates and Extensions';
const SHORTCUT_SECTION_MONITORING = 'Monitoring';
const SHORTCUT_SECTIONS = [
  SHORTCUT_SECTION_CREATION,
  SHORTCUT_SECTION_BRANDING,
  SHORTCUT_SECTION_LINKS,
  SHORTCUT_SECTION_UPDATES,
  SHORTCUT_SECTION_MONITORING,
];

class AutomationHub extends Component {
  constructor(props) {
    super(props);
    const { activeWhiteLabel } = props;
    this.state = {
      selectedShortcut: null,
      sectionIndex: activeWhiteLabel.Section || 0,
      // sectionIndex: 3,
      stepIndex: activeWhiteLabel.Step || 0,
    };
    this.shortcuts = [
      {
        key: SHORTCUT_WHITELABEL,
        section: SHORTCUT_SECTION_CREATION,
        label: (
          <div style={{ overflow: 'hidden' }}>
            New Whitelabel Environment
            <br /> + Apps
          </div>
        ),
        icon: 'plus',
        sections: [
          {
            key: 'AWSAccount',
            label: '1 - Create Account',
            render: (stepIndex) => <AWSAccount onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
          },
          {
            key: 'CommunityManagerSetup',
            label: '2 - Set up Web',
            render: (stepIndex) => <CommunityManagerSetup onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
          },
          {
            key: 'AppSetupiOS',
            label: '3 - Set up iOS',
            render: (stepIndex) => <AppSetupiOS onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
          },
          {
            key: 'AppSetupAndroid',
            label: '4 - Set up Android',
            render: (stepIndex) => <AppSetupAndroid onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
          },
        ],
      },
      {
        key: SHORTCUT_SECONDARY_APP,
        section: SHORTCUT_SECTION_CREATION,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Secondary Apps
            <br />
            Under An
            <br />
            Environment
          </div>
        ),
        icon: 'mobile',
        sections: [
          {
            key: 'AddSubApp',
            label: '',
            render: () => <AddSubApp onChangeShortcut={this.onSelectShortcut} />,
          },
        ],
      },
      {
        key: SHORTCUT_APP_COLOURS,
        section: SHORTCUT_SECTION_BRANDING,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Replace App
            <br />
            Colours
          </div>
        ),
        icon: 'paint-brush',
        sections: [
          {
            key: 'ReplaceAppColours',
            label: '',
            render: () => <ReplaceAppColours />,
          },
        ],
      },
      {
        key: SHORTCUT_APP_IMAGES,
        section: SHORTCUT_SECTION_BRANDING,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Replace App
            <br />
            Images
          </div>
        ),
        icon: 'file-image-o',
        sections: [
          {
            key: 'ReplaceAppAssets',
            label: '',
            render: () => <ReplaceAppAssets />,
          },
        ],
      },
      {
        key: SHORTCUT_APP_LINKS,
        section: SHORTCUT_SECTION_LINKS,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Add Store
            <br />
            Links
          </div>
        ),
        icon: 'link',
        sections: [
          {
            key: 'AddAppLinks',
            label: '',
            render: () => <AddAppLinks />,
          },
        ],
      },
      {
        key: SHORTCUT_STORE_UPGRADE,
        section: SHORTCUT_SECTION_UPDATES,
        label: 'Store Release Upgrade',
        icon: 'wrench',
        sections: [
          {
            key: 'BuildApp',
            label: '',
            render: () => <BuildApp />,
          },
        ],
      },
      {
        key: SHORTCUT_BEAMED_UPGRADE,
        section: SHORTCUT_SECTION_UPDATES,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Beamed
            <br />
            Upgrade
          </div>
        ),
        icon: 'cloud-upload',
        sections: [
          {
            key: 'Deployment',
            label: '',
            render: () => <Deployment />,
          },
        ],
      },
      {
        key: SHORTCUT_FEATURE_ADDITION,
        section: SHORTCUT_SECTION_UPDATES,
        label: (
          <div style={{ overflow: 'hidden' }}>
            Feature
            <br />
            Additions
          </div>
        ),
        icon: 'puzzle-piece',
        sections: [
          {
            key: 'Extensions',
            label: '',
            render: () => <Extensions />,
          },
        ],
      },
      {
        key: SHORTCUT_APP_DASHBOARD,
        section: SHORTCUT_SECTION_MONITORING,
        label: <div style={{ overflow: 'hidden' }}>App Dashboard</div>,
        icon: 'tachometer',
        sections: [
          {
            key: 'AppDashboard',
            label: '',
            render: () => <AppDashboard />,
          },
        ],
      },
    ];
  }

  componentDidMount() {
    // this.setState({
    //   selectedShortcut: {
    //     key: SHORTCUT_WHITELABEL,
    //     section: SHORTCUT_SECTION_CREATION,
    //     label: (
    //       <div style={{ overflow: 'hidden' }}>
    //         New Whitelabel Environment
    //         <br /> + Apps
    //       </div>
    //     ),
    //     icon: 'plus',
    //     sections: [
    //       {
    //         key: 'AWSAccount',
    //         label: '1 - Create Account',
    //         render: (stepIndex) => <AWSAccount onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
    //       },
    //       {
    //         key: 'CommunityManagerSetup',
    //         label: '2 - Set up Web',
    //         render: (stepIndex) => <CommunityManagerSetup onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
    //       },
    //       {
    //         key: 'AppSetupiOS',
    //         label: '3 - Set up iOS',
    //         render: (stepIndex) => <AppSetupiOS onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
    //       },
    //       {
    //         key: 'AppSetupAndroid',
    //         label: '4 - Set up Android',
    //         render: (stepIndex) => <AppSetupAndroid onDone={this.onDone} onMoveStep={this.onMoveStep} stepIndex={stepIndex} />,
    //       },
    //     ],
    //   },
    // });
  }

  onSaveWhiteLabel = async ({ sectionIndex, stepIndex } = { sectionIndex: null, stepIndex: null }) => {
    const { activeWhiteLabel } = this.props;
    if (!activeWhiteLabel || !activeWhiteLabel.RowId) return;

    const update = _.cloneDeep(activeWhiteLabel);
    if (sectionIndex || sectionIndex === 0) update.Section = sectionIndex;
    if (stepIndex || stepIndex === 0) update.Step = stepIndex;
    try {
      const { data } = await automationActions.updateWhiteLabel(update, activeWhiteLabel);
      this.props.whiteLabelLoaded(data);
    } catch (error) {
      console.log('onSaveWhiteLabel error', getApiError(error).message);
    }
  };

  onSelectShortcut = (shortcut) => {
    let selectedShortcut = shortcut;
    if (typeof selectedShortcut === 'string') {
      selectedShortcut = this.shortcuts.find((s) => s.key === selectedShortcut);
    }
    this.setState({ selectedShortcut });
  };

  onSelectSection = (newIndex) => {
    const { sectionIndex, stepIndex } = this.state;
    // console.log('onSelectSection', { newIndex, sectionIndex, stepIndex });
    const newStepIndex = sectionIndex !== newIndex || newIndex === 0 ? 0 : stepIndex;
    this.setState({ sectionIndex: newIndex, stepIndex: newStepIndex }, () =>
      this.onSaveWhiteLabel({ sectionIndex: this.state.sectionIndex, stepIndex: this.state.stepIndex }),
    );
  };

  onDone = () => {
    const { sectionIndex } = this.state;
    const whiteLabelShortcut = this.shortcuts.find((s) => s.key === SHORTCUT_WHITELABEL);
    if (whiteLabelShortcut) {
      if (sectionIndex < whiteLabelShortcut.sections.length - 1) this.onSelectSection(sectionIndex + 1);
    }
  };

  onMoveStep = (stepIndex) => {
    this.setState({ stepIndex }, () => this.onSaveWhiteLabel({ stepIndex: this.state.stepIndex }));
  };

  renderShortcut(shortcut) {
    return (
      <div key={shortcut.key} className="dashboardButton" onClick={() => this.onSelectShortcut(shortcut)}>
        <div className="dashboardButton_inner">
          <div className="dashboardButton_iconContainer">
            <FontAwesome className="dashboardButton_icon" name={shortcut.icon} />
          </div>
          <div className="dashboardButton_text" style={{ fontSize: 16, height: 80, width: 150, marginBottom: -30 }}>
            {shortcut.label}
          </div>
        </div>
      </div>
    );
  }

  renderShortcuts() {
    const sectionInfo = SHORTCUT_SECTIONS.map((title) => {
      return {
        title,
        shortcuts: this.shortcuts.filter((s) => s.section === title),
      };
    });
    return sectionInfo.map((section) => {
      return (
        <div key={section.title} className="marginRight-40 marginBottom-20">
          <div className="text-h4 dashboardButtons_title">{section.title}</div>
          <div>{section.shortcuts.map((s) => this.renderShortcut(s))}</div>
        </div>
      );
    });
  }

  renderLeftBar() {
    const { selectedShortcut } = this.state;
    const sectionItems = selectedShortcut
      ? selectedShortcut.sections
          .filter((section) => !_.isEmpty(section.label))
          .map((section, index) => {
            return {
              type: 'navItem',
              text: section.label,
              selected: this.state.selectedSection === index,
              onClick: () => this.onSelectSection(index),
            };
          })
      : [];
    if (selectedShortcut) {
      sectionItems.splice(0, 0, {
        type: 'button',
        text: 'Home',
        onClick: () => this.setState({ selectedShortcut: null, sectionIndex: 0, stepIndex: 0 }),
      });
    }

    return (
      <HubSidebar
        sections={[
          {
            title: 'Automation',
            items: sectionItems,
          },
        ]}
      />
    );
  }

  renderRight() {
    const { selectedShortcut, sectionIndex, stepIndex } = this.state;
    if (selectedShortcut && sectionIndex < selectedShortcut.sections.length) {
      return selectedShortcut.sections[sectionIndex].render(stepIndex);
    }
    return this.renderShortcuts();
  }

  render() {
    return (
      <div className="hub-wrapperContainer">
        {this.renderLeftBar()}
        <div className="hub-headerContentWrapper">
          <Header />
          <div className="hub-contentWrapper" style={{ flexWrap: 'wrap', alignContent: 'flex-start' }}>
            {this.renderRight()}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  sideBarTitleSection: {
    lineHeight: '50px',
    marginTop: 30,
    marginBottom: 30,
    paddingLeft: 24,
    paddingRight: 32,
    whiteSpace: 'nowrap',
  },
};

const mapStateToProps = (state) => {
  const { auth, automation } = state;
  // console.log('automation.active', automation.active);
  return {
    auth,
    activeWhiteLabel: automation.active,
  };
};

export default connect(mapStateToProps, { whiteLabelLoaded })(AutomationHub);
